<!--
 * Purpose: Vue component for managing Employee Types (CRUD, drafts, approvals).
 * Decision ID: [DECISION-006]
 * Date: 2026-06-24
-->
<template>
    <div class="clearfix pb-3 px-0 ml-0">

        <!-- alpha fix- added this breadcumb  -->
          <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0" v-if="this.flg != 1">HR Settings<span>
                <!-- AbdullahALC chnaged pageurl to api url -->
                <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / HR Settings / Employee Types</span>
        </h4>

        <b-alert v-model="hasDraft" class="position-fixed fixed-top m-0 rounded-0" style="z-index: 2000;" variant="info" dismissible>There are some draft employee types.</b-alert>
        <div class="row no-margin mt-4">
            <div class="ibox col-md-12 px-4 employee-table-wrapper">
                <div class="ibox-title dashboard_title px-0">
                    <h4>Employee Types</h4>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="custom-search w-100">
                            <b-input-group class="mb-0">
                                <b-input-group-prepend is-text>
                                    <b-icon icon="search"></b-icon>
                                </b-input-group-prepend>
                                <b-form-input type="search" placeholder="Search.." v-model="search" @input="resetPagination()"></b-form-input>
                            </b-input-group>
                        </div>
                    </div>
                    <div class="col-md-6 text-right">
                        <b-button id="show-btn" class="mr-3 custom-wizard-btn" @click="addNew(true)">Add Multiple Employee Types</b-button>
                        <b-button id="show-btn" class="btn-primary" @click="addNew(false)">Add Employee Type</b-button>
                    </div>
                </div>

                <div class="ibox-content px-0 mt-4">
                    <b-overlay :show="showoverlay_list" rounded="sm" class="">
                        <table class="table">
                            <thead>
                                <tr class="table-head">
                                    <td style="width: 60px;" class="">#SL</td>
                                    <td>Employee Type Title</td>
                                    <td style="width: 100px;" v-if="permission >= 2" class="">Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover-bg table-row border-bottom mx-2" v-for="(employeeType , n) in paginatedData" :key="employeeType.id">
                                    <!-- alpha fix- added class text-center  -->
                                    <td class="align-middle list-columns text-center">{{employeeType.index}}</td>

                                    <td class="align-middle list-columns">
                                        <template v-if="employeeType.name_draft">{{employeeType.name_draft}}</template>
                                        <template v-else>{{employeeType.name}}</template>
                                    </td>

                                    <td class="clearfix align-middle" v-if="permission >= 2">
                                        <div class="float-right mr-2 position-relative">
                                            <b-button-toolbar>
                                                <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                                <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                    <b-button-group class="mr-0">
                                                        <b-button variant="outline-secondary" title="Edit Employee Type" @click="editEmployeeType(employeeType.id)">
                                                            <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                        </b-button>
                                                        <b-button v-if="permission == 2" variant="outline-secondary" title="Delete Employee Type" @click="deleteEmployeeType(employeeType.id)">
                                                            <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                        </b-button>
                                                    </b-button-group>
                                                </div>
                                            </b-button-toolbar>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
                        <div v-else class="row py-2 no-margin">
                            <div class="col-md-12 p-0 no-margin">
                                <ul class="pagination b-pagination float-left mb-0 mt-1">
                                    <li class="page-item disabled m-2">View</li>
                                    <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                    <li class="page-item disabled m-2">per page. Total {{people}} records found.</li>
                                </ul>
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                            </div>
                        </div>

                        <div v-if="this.flg == 1" class="mt-3">
                           <div class="text-center">
                            <b-button type="button" @click="set_go_back(1)" variant="primary" class="btn-primary mt-3 mr-3">Go Back</b-button>
                            <b-button type="button" @click="setfinish(1)" variant="success" class="custom-wizard-btn  btn-primary mt-3 mx-3">Finish</b-button>
                            <b-button type="button" @click="set_go_next(1)" variant="primary" class="btn-primary mt-3 mr-3">Go Next</b-button>
                           </div>
                        </div>

                    </b-overlay>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-sm-12  px-0" v-if="permission >= 2">
                <b-modal id="bv-modal-employeetype" size="lg" hide-footer :title="employeetype_details">
                    <b-overlay :show="showoverlay" rounded="sm">

                        <template v-if="fdata.id > 0">
                            <b-form @submit.stop.prevent="onSubmit">
                                <div class="clearfix">
                                    <div class="px-3">
                                        <input type="hidden" v-model="fdata.id" name="id">

                                        <b-form-group  id="name-group" label="Employee Type Title" class="required-field radius-8" label-for="name">
                                            <b-input-group>
                                                <b-form-input id="name" name="name"  class="radius-8" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Name"></b-form-input>

                                                <b-input-group-append v-if="fdata.name_draft" v-b-tooltip.hover :title="saved_name"><b-icon icon="pencil-square" class="ml-1 mt-2"></b-icon></b-input-group-append>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-input-group>
                                        </b-form-group>

                                        <template v-if="(fdata.name_draft) && (permission == 2)">
                                            <div class="btn-wrapper text-center pt-5">
                                                <b-button class="btn-primary" type="submit" variant="primary" >Approve</b-button>
                                                <b-button class="btn-primary" v-if="(fdata.name_draft) && (permission == 2)" @click="resetEmployeeType(fdata.id)" type="button" variant="primary" >Reset</b-button>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="btn-wrapper text-center pt-5">
                                                <b-button class="btn-primary" type="submit" variant="primary" >Update</b-button>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                            </b-form>
                        </template>
                        <template v-else>
                            <b-form @submit.stop.prevent="onSubmit">
                                <div class="clearfix">
                                    <div class="px-3">
                                        <input type="hidden" v-model="fdata.id" name="id">

                                        <template v-if="addtype == true">
                                            <b-form-group id="name-group" label="Employee Type Title(s)" class="required-field gray-textarea" label-for="name" description="Add new employee type title in new line for multiple entry">
                                                <b-form-textarea id="name" name="name" rows="5" v-model="fdata.name" v-validate="{ required: true }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Employee Type Title"></b-form-textarea>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>

                                        <template v-else>
                                            <b-form-group id="name-group" label="Employee Type Title" class="required-field radius-8" label-for="name">
                                                <b-form-input id="name"  class="radius-8" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Employee Type Title"></b-form-input>
                                                <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                            </b-form-group>
                                        </template>

                                        <div class="btn-wrapper text-center pt-5">
                                            <label style="opacity: 0; display: none;">label</label>
                                            <b-button class="btn-primary" v-if="fdata.id > 0" type="submit" variant="primary" style="">Edit Employee Type</b-button>
                                            <b-button class="btn-primary" v-else type="submit" variant="primary" style="">Submit</b-button>
                                        </div>
                                    </div>
                                </div>
                            </b-form>
                        </template>
                    </b-overlay>
                </b-modal>

                <b-modal id="bv-modal-employeetype-draft" size="lg" hide-footer title="Employee Type Details">
                    <b-overlay :show="showoverlay" rounded="sm">
                        <b-form @submit.stop.prevent="saveDraftEmployeeType">
                            <div class="clearfix">
                                <div class="px-3">
                                    <input type="hidden" v-model="draftdata.id" name="id">

                                    <b-form-group id="name-group" label="Employee Type Title" class="required-field radius-8" label-for="name">
                                        <b-form-input id="name"  class="radius-8" name="name" v-model="draftdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Employee Type Title"></b-form-input>
                                        <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                                    </b-form-group>

                                    <label style="opacity: 0;">label</label>
                                    <b-button type="submit" variant="success" style="width: 100%;"><b-icon variant="light" icon="pencil" scale="1" width="20px" height="20px" class="align-left mr-2"></b-icon>Update Draft Data</b-button>
                                </div>
                            </div>
                        </b-form>
                    </b-overlay>
                </b-modal>
            </div>

            <div class="col-sm-12  px-0 mt-5" v-if="draft_employeetypes.length > 0">
                <div class="px-3 mb-2 company-form-box-title">New Employee Types (Waiting for Approval)</div>
                <b-overlay :show="showoverlay_list" rounded="sm">
                    <table class="table list-tables">
                        <thead>
                            <tr class="table-head">
                                <td class="pl-5">#</td>
                                <td>Employee Type Title</td>
                                <td v-if="permission >= 2" class="float-right">Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="(employeeType , n) in draft_employeetypes" :key="employeeType.id">
                                <td class="col-md-1 align-middle list-columns pl-5">{{ parseInt(n+1) }}</td>
                                <td class="col-md-5 align-middle list-columns">
                                    <div class=" ">{{employeeType.name}}</div>
                                </td>

                                <td class="clearfix col-md-6 align-middle" v-if="permission >= 2">
                                    <div class="float-right mr-2 position-relative">
                                        <b-button-toolbar>
                                            <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
                                             <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                                <b-button-group class="mr-0">
                                                    <b-button v-if="permission == 2" variant="outline-secondary" title="Approve Employee Type" @click="approveEmployeeType(employeeType.id)">
                                                        <b-icon icon="check2" class="mr-2" aria-hidden="true" ></b-icon>Approve
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Edit Employee Type" @click="editDraftEmployeeType(employeeType.id)">
                                                        <b-icon icon="pencil" class="mr-2" aria-hidden="true" ></b-icon>Edit
                                                    </b-button>
                                                    <b-button variant="outline-secondary" title="Delete Employee Type" @click="deleteDraftEmployeeType(employeeType.id)">
                                                        <b-icon icon="trash" class="mr-2" aria-hidden="true"></b-icon>Delete
                                                    </b-button>
                                                </b-button-group>
                                            </div>
                                        </b-button-toolbar>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.permission = this.$acl['employeetype/details'] || 0;
        },
        props: ['ce_flg' , 'check_ce' , 'flg'],
        data() {
            return {
                employeetypes: [],
                draft_employeetypes: [],
                errormsg: [],
                fdata: {status: null, id: null, name: null},
                saved_name: '',
                successmsg: null,
                warningmsg: null,
                draftdata: {},
                file: null,
                showoverlay: false,
                showoverlay_list: false,
                go_back: false,
                go_next: false,
                finish: false,
                search: '',
                length: 20,
                temp_length: 20,
                length_options: [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],
                people: 0,
                pagination: {currentPage: 1, pages: 1},
                addtype: false,
                permission: 0,
                hasDraft: false,
                employeetype_details: 'Employee Type Details',
            }
        },
        methods: {
            showMessage() {
                let tmp_flg = 0;
                if (this.employeetypes.length > 0) tmp_flg = 1;
                let childdata = {flg: tmp_flg, successmsg: this.successmsg, warningmsg: this.warningmsg, dangermsg: this.dangermsg, move_next: this.go_next, move_back: this.go_back, finish: this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x) {
                this.go_next = false;
                this.go_back = true;
                this.finish = false;
                if (x == 1) this.showMessage();
            },
            set_go_next(x) {
                this.go_next = true;
                this.go_back = false;
                this.finish = false;
                if (x == 1) this.showMessage();
            },
            disable_set_go_next() {
                this.go_next = false;
            },
            setfinish(x) {
                this.finish = true;
                this.go_next = false;
                this.go_back = false;
                if (x == 1) this.showMessage();
            },
            addNew(x) {
                this.addtype = x;
                this.resetForm();
                if (x == true) {
                    this.employeetype_details = 'Add Multiple Employee Types';
                } else {
                    this.employeetype_details = 'Add Employee Type';
                }
                this.$bvModal.show('bv-modal-employeetype');
            },
            getEmployeeTypeData() {
                if (!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url + '/employeetype/list')
                    .then(response => {
                        this.employeetypes = response.data;
                        this.people = this.employeetypes.length;
                    })
                    .catch(error => { currentObj.serverError(error); });
            },
            getDraftEmployeeTypeData() {
                if (!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url + '/employeetype/list/draft')
                    .then(response => {
                        this.draft_employeetypes = response.data;
                        this.hasDraft = this.draft_employeetypes.length > 0;
                    })
                    .catch(error => { currentObj.serverError(error); });
            },
            editDraftEmployeeType(x) {
                this.employeetype_details = 'Edit Employee Type';
                this.addtype = false;
                if (!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url + '/employeetype/details/draft', { params: { id: x } })
                    .then(response => {
                        this.draftdata = response.data;
                        this.$validator.reset();
                        this.showoverlay = false;
                        this.$bvModal.show('bv-modal-employeetype-draft');
                    })
                    .catch(error => { this.showoverlay = false; currentObj.serverError(error); });
            },
            saveDraftEmployeeType(e) {
                if (!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) return;
                    e.preventDefault();
                    let currentObj = this;
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.draftdata)) {
                        formData.append(key, value);
                    }
                    axios.post(this.$api_url + '/employeetype/save/draft', formData)
                        .then(response => {
                            this.getDraftEmployeeTypeData();
                            this.$bvToast.toast('Saved!', { title: `Success`, variant: 'success', solid: true });
                            this.resetForm();
                            this.$bvModal.hide('bv-modal-employeetype-draft');
                        })
                        .catch(error => {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },
            deleteDraftEmployeeType(x) {
                if (!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this draft employee type.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('id', x);
                        axios.post(this.$api_url + '/employeetype/delete/draft', formData).then(response => {
                            this.getDraftEmployeeTypeData();
                            this.$bvToast.toast('Deleted!', { title: `Success`, variant: 'success', solid: true });
                        });
                    }
                });
            },
            approveEmployeeType(x) {
                if (!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to approve this draft employee type.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('id', x);
                        axios.post(this.$api_url + '/employeetype/approve/draft', formData).then(response => {
                            this.getEmployeeTypeData();
                            this.getDraftEmployeeTypeData();
                            this.$bvToast.toast('Approved!', { title: `Success`, variant: 'success', solid: true });
                        });
                    }
                });
            },
            resetEmployeeType(x) {
                if (!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to reset this employee type data.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('id', x);
                        axios.post(this.$api_url + '/employeetype/reset', formData).then(response => {
                            this.getEmployeeTypeData();
                            this.editEmployeeType(x);
                            this.$bvToast.toast('Saved', { title: `Success`, variant: 'success', solid: true });
                        });
                    }
                });
            },
            editEmployeeType(x) {
                this.employeetype_details = 'Edit Employee Type';
                this.addtype = false;
                if (!this.checkNet()) return false;
                let currentObj = this;
                this.showoverlay = true;
                axios.get(this.$api_url + '/employeetype/details', { params: { id: x } })
                    .then(response => {
                        this.fdata = response.data;
                        this.saved_name = response.data.name;
                        if ((this.fdata.name_draft != '') && (this.fdata.name_draft != null)) {
                            this.fdata.name = this.fdata.name_draft;
                        }
                        this.$validator.reset();
                        this.showoverlay = false;
                        this.$bvModal.show('bv-modal-employeetype');
                    })
                    .catch(error => { this.showoverlay = false; currentObj.serverError(error); });
            },
            deleteEmployeeType(x) {
                if (!this.checkNet()) return false;
                this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this employee type.', {
                    title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
                })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        let currentObj = this;
                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', x);
                        axios.post(this.$api_url + '/employeetype/delete', formData)
                            .then(response => {
                                if (response.data.status == true) {
                                    this.successmsg = response.data.meg;
                                    this.$bvToast.toast(response.data.meg, { title: `Success`, variant: 'success', solid: true });
                                    this.employeetypes = response.data.employee_types;
                                    this.resetPagination();
                                } else {
                                    this.warningmsg = response.data.meg;
                                    this.$bvToast.toast(response.data.meg, { title: `Warning`, variant: 'warning', solid: true });
                                }
                                this.showoverlay_list = false;
                            })
                            .catch(error => { currentObj.serverError(error); });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetForm() {
                this.fdata = {name: null, status: null, id: null};
                this.file = null;
                this.$nextTick(() => { this.$validator.reset(); });
            },
            onSubmit(e) {
                if (!this.checkNet()) return false;
                this.warningmsg = null;
                this.successmsg = null;
                this.$validator.validateAll().then(result => {
                    if (!result) return;
                    e.preventDefault();
                    let currentObj = this;
                    const config = { headers: { 'content-type': 'multipart/form-data' } };
                    let formData = new FormData();
                    for (let [key, value] of Object.entries(this.fdata)) {
                        formData.append(key, value);
                    }
                    axios.post(this.$api_url + '/employeetype/save', formData, config)
                        .then(response => {
                            this.employeetypes = response.data;
                            this.getDraftEmployeeTypeData();
                            this.successmsg = 'Saved!';
                            this.$bvToast.toast('Saved!', { title: `Success`, variant: 'success', solid: true });
                            this.resetForm();
                            this.$bvModal.hide('bv-modal-employeetype');
                        })
                        .catch(error => {
                            currentObj.serverError(error);
                            currentObj.errormsg = error.response.data.errors;
                        });
                });
            },
            resetPagination() {
                this.pagination.currentPage = 1;
            },
            setFirstPage() {
                this.pagination.currentPage = 1;
                this.length = this.temp_length;
            },
            paginate(array, page_size, page_number) {
                return array.slice((page_number - 1) * page_size, page_number * page_size);
            }
        },
        created() {
            this.getEmployeeTypeData();
            this.getDraftEmployeeTypeData();
        },
        computed: {
            filteredData() {
                let filtered_list = this.employeetypes;
                if (this.search) {
                    filtered_list = filtered_list.filter(row => {
                        return Object.keys(row).some(key => {
                            return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;
                        });
                    });
                }
                let n = 1;
                filtered_list.forEach(row => {
                    row.index = n++;
                });
                return filtered_list;
            },
            paginatedData() {
                this.people = this.filteredData.length;
                this.pagination.pages = Math.ceil(this.people / this.length) || 1;
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            }
        }
    }
</script>
